import { makeActionCreator } from '../../../utilities'
import { PcrBackupConstants } from './pcrBackup.constants'

export const pcrSaved = makeActionCreator(PcrBackupConstants.PCR_SAVED, 'pcrId')
export const setBackupMetadata = makeActionCreator(PcrBackupConstants.SET_METADATA, 'metadata')
export const resetPcrBackupMetadata = makeActionCreator(PcrBackupConstants.RESET)
export const persistPrid = makeActionCreator(PcrBackupConstants.PERSIST_PRID, 'pcrId', 'prid')
